export const MUSIC_POLICY = Object.freeze({
  minimumPreDropSeconds: 14,
  minimumPostDropSeconds: 20,
  maxDurationSeconds: 40,
  marginSeconds: 3,
  maxUploadBytes: 8 * 1024 * 1024,
  maxSourceBytes: 100 * 1024 * 1024,
  maxSourceDurationSeconds: 600,
  minAmountCents: 200,
  defaultValidityMonths: 3,
  titleMaxLength: 160,
  authorMaxLength: 160,
  linkMaxLength: 2048,
  sampleRate: 48000,
});

export interface MusicWindow {
  readonly startSeconds: number;
  readonly endSeconds: number;
  readonly dropSeconds: number;
  readonly missingBeforeSeconds: number;
  readonly missingAfterSeconds: number;
  readonly valid: boolean;
}

export function musicWindow(durationSeconds: number, dropSeconds: number): MusicWindow {
  if (!Number.isFinite(durationSeconds) || durationSeconds < 0 || !Number.isFinite(dropSeconds)
    || dropSeconds < 0 || dropSeconds > durationSeconds) throw new Error('Invalid audio timeline.');
  const startSeconds = Math.max(0, dropSeconds - MUSIC_POLICY.minimumPreDropSeconds - MUSIC_POLICY.marginSeconds);
  const endSeconds = Math.min(durationSeconds, dropSeconds + MUSIC_POLICY.minimumPostDropSeconds + MUSIC_POLICY.marginSeconds);
  const missingBeforeSeconds = Math.max(0, MUSIC_POLICY.minimumPreDropSeconds - dropSeconds);
  const missingAfterSeconds = Math.max(0, MUSIC_POLICY.minimumPostDropSeconds - (durationSeconds - dropSeconds));
  return { startSeconds, endSeconds, dropSeconds: dropSeconds - startSeconds,
    missingBeforeSeconds, missingAfterSeconds, valid: missingBeforeSeconds === 0 && missingAfterSeconds === 0 };
}

export function validMusicDrop(durationSeconds: number, dropSeconds: number): boolean {
  return Number.isFinite(durationSeconds) && Number.isFinite(dropSeconds)
    && durationSeconds <= MUSIC_POLICY.maxDurationSeconds
    && dropSeconds >= MUSIC_POLICY.minimumPreDropSeconds
    && durationSeconds - dropSeconds >= MUSIC_POLICY.minimumPostDropSeconds;
}
